import { JetView } from 'webix-jet';
import { profile, devConfig, countries, paymentSystem, cashDesks, agentList } from 'config/config';

/**
 * Class representing the FilterDepositReportsView.
 * @extends JetView
 */
export default class FilterDepositReportsView extends JetView {
    /**
     * Configures the UI components of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._;
        const left = {
            margin: 5,
            id: 'a1',
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'a1',
                    cols: [
                        {
                            view: 'text',
                            name: 'Datepicker',
                            id: 'Datepicker',
                            css: 'reportrange',
                            value:
                                moment().subtract(0, 'days').format('YYYY-MM-DD') +
                                ' - ' +
                                moment().format('YYYY-MM-DD'),
                            minWidth: 200,
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                        },
                        {
                            view: 'datepicker',
                            name: 'Date',
                            id: 'Date',
                            stringResult: true,
                            minWidth: 200,
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            value: moment().format('YYYY-MM-DD'),
                            format: '%d %M %Y',
                            suggest: {
                                type: 'calendar',
                                body: {
                                    maxDate: new Date(),
                                },
                            },
                        },
                        {
                            view: 'text',
                            name: 'PlayerId',
                            type: 'number',
                            label: "<span class='icon-user'></span>" + _('ID Usuario'),
                            hidden: !devConfig.getPermAction('filterByUser', 'Add'),
                            css: 'prm-filterByUser',
                            labelPosition: 'top',
                            minWidth: 200,
                            placeholder: _('ID Usuario'),
                            invalidMessage: _('ID Usuario is required'),
                        },
                        {
                            view: 'richselect',
                            name: 'CountrySelect',
                            id: 'CountrySelect',
                            label: "<span class='icon-language'></span>" + _('País'),
                            labelPosition: 'top',
                            minWidth: 200,
                            placeholder: _('Click para seleccionar '),
                            options: {
                                body: {
                                    template: function (obj) {
                                        return "<i class='flags " + obj.icon + "'></i>" + obj.value;
                                    },
                                    data: countries,
                                },
                            },
                            hidden: devConfig.getCountryReport() || !devConfig.getPermAction('filterByCountry', 'Add'),
                            css: 'prm-filterByCountry',
                        },
                        {
                            view: 'richselect',
                            name: 'CountrySelect2',
                            label: "<span class='icon-language'></span>" + _('País'),
                            labelPosition: 'top',
                            minWidth: 200,
                            placeholder: _('Click para seleccionar '),
                            value: profile.Settings.ReportCountry,
                            readonly: true,
                            options: {
                                body: {
                                    template: function (obj) {
                                        return "<i class='flags " + obj.icon + "'></i>" + obj.value;
                                    },
                                    data: countries,
                                },
                            },
                            hidden: !devConfig.getCountryReport() || !devConfig.getPermAction('filterByCountry', 'Add'),
                            css: 'prm-filterByCountry',
                            css: 'country-hide',
                        },
                        {
                            view: 'richselect',
                            name: 'State',
                            localId: 'bonusStates:combo',
                            label: "<span class='icon-state'></span>" + _('Estado'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [
                                {
                                    id: '',
                                    value: _('Todos'),
                                },
                                {
                                    id: 'A',
                                    value: _('Abierto'),
                                },
                                {
                                    id: 'I',
                                    value: _('Cerrado'),
                                },
                            ],
                        },
                    ],
                },
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'a1',
                    cols: [
                        {
                            view: 'checkbox',
                            label: _('Resumen por Proveedor'),
                            labelPosition: 'top',
                            name: 'IsDetails',
                            id: 'IsDetails',
                            value: 1,
                            minWidth: 200,
                        },
                    ],
                },
                {
                    margin: 15,
                    css: 'on-row',
                    id: 'Sort',
                    cols: [
                        {
                            view: 'combo',
                            name: 'Sort',
                            label: _('Ordenar por'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [
                                { id: '1', value: _('ID Usuario') },
                                { id: '2', value: _('Fecha de Creación') },
                                { id: '3', value: _('Valor') },
                            ],
                            value: '1',
                        },
                        {
                            view: 'combo',
                            name: 'Dir',
                            label: _('Orden'),
                            labelPosition: 'top',
                            options: [
                                { id: '0', value: _('Ascendente') },
                                { id: '1', value: _('Descendente') },
                            ],
                            value: '0',
                        },
                        { gravity: 1, id: 'grav2' },
                        { gravity: 1, id: 'grav3' },
                    ],
                },
            ],
        };
        const left2 = {
            margin: 5,
            id: 'a8',
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'a8',
                    cols: [
                        {
                            view: 'combo',
                            name: 'PaymentSystemId',
                            minWidth: 200,
                            label: "<span class='icon-credit-card'></span>" + _('Tipo Pasarela de Pago'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            id: 'PaymentSystemId',
                            options: {
                                body: {
                                    dataFeed: function (text) {
                                        var vthis = this;
                                        webix
                                            .ajax()
                                            .headers({
                                                'Content-type': 'application/json',
                                            })
                                            .post(
                                                devConfig.geturlApi() + 'es/Select/PaymentSystemsSelect',
                                                '{"Filter":"' + text + '"}',
                                                {
                                                    error: function (text, data, XmlHttpRequest) {
                                                        webix.message('Error! ');
                                                    },
                                                    success: function (text, data, XmlHttpRequest) {
                                                        var resp = JSON.parse(text);
                                                        if (!resp.HasError) {
                                                            vthis.parse(resp.Data);
                                                        }
                                                    },
                                                },
                                            );
                                    },
                                },
                            },
                        },
                        {
                            view: 'combo',
                            name: 'BetShopId',
                            minWidth: 200,
                            label: "<span class='icon-shop'></span>" + _('Punto de Venta'),
                            hidden: !devConfig.getPermAction('filterByBetShop', 'Add'),
                            css: 'prm-filterByBetShop',
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            id: 'BetShopId',
                            options: {
                                body: {
                                    dataFeed: function (text) {
                                        var vthis = this;
                                        if (text.length > 2) {
                                            webix
                                                .ajax()
                                                .headers({
                                                    'Content-type': 'application/json',
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'es/Select/BetShopsSelect',
                                                    '{"Filter":"' + text + '"}',
                                                    {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            webix.message('Error! ');
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            var resp = JSON.parse(text);
                                                            if (!resp.HasError) {
                                                                vthis.parse(resp.Data);
                                                            }
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            },
                        },
                        {
                            view: 'combo',
                            name: 'AgentList',
                            minWidth: 200,
                            label: "<span class='icon-user-secret'></span>" + _('Agente'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            id: 'AgentList',
                            options: {
                                body: {
                                    dataFeed: function (text) {
                                        var vthis = this;
                                        if (text.length > 2) {
                                            webix
                                                .ajax()
                                                .headers({
                                                    'Content-type': 'application/json',
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'es/Select/AgentListSelect',
                                                    '{"Filter":"' + text + '"}',
                                                    {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            webix.message('Error! ');
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            var resp = JSON.parse(text);
                                                            if (!resp.HasError) {
                                                                vthis.parse(resp.Data);
                                                            }
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            },
                        },
                        {
                            view: 'text',
                            name: 'Ip',
                            minWidth: 200,
                            label: "<span class='icon-ip'></span>" + _('Dirección IP'),
                            labelPosition: 'top',
                            placeholder: _('Dirección IP'),
                        },
                    ],
                },
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'a8',
                    cols: [
                        {
                            view: 'text',
                            name: 'ExternalId',
                            type: 'number',
                            minWidth: 200,
                            label: "<span class='icon-id'></span>" + _('External ID'),
                            labelPosition: 'top',
                            placeholder: _('External ID'),
                        },
                        {
                            view: 'combo',
                            name: 'ProviderId',
                            id: 'ProvidersPaymentSystem',
                            minWidth: 200,
                            label: _('Proveedor pasarela de pago'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                        },
                        {
                            view: 'text',
                            name: 'ValueMinimum',
                            type: 'number',
                            minWidth: 200,
                            label: "<span class='icon-cash'></span>" + _('Valor Mínimo'),
                            labelPosition: 'top',
                            placeholder: _('Valor Mínimo'),
                        },
                        {
                            view: 'text',
                            name: 'ValueMaximum',
                            type: 'number',
                            minWidth: 200,
                            label: "<span class='icon-cash'></span>" + _('Valor Máximo'),
                            labelPosition: 'top',
                            placeholder: _('Valor Máximo'),
                        },
                    ],
                },
            ],
        };
        const upper_section = {
            css: 'father-container',
            id: 'upper_section',
            rows: [
                {
                    margin: 10,
                    cols: [left],
                },
            ],
        };
        const upper_section2 = {
            css: 'father-container',
            rows: [
                {
                    margin: 10,
                    cols: [left2],
                },
            ],
        };
        const accordion_section = {
            id: 'b5',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: true,
                    paddingY: 10,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros Avanzados'),
                            body: {
                                padding: 10,
                                rows: [upper_section2],
                            },
                        },
                    ],
                },
            ],
        };
        const buttons = {
            margin: 10,
            cols: [
                {},
                {
                    view: 'button',
                    value: _('Limpiar'),
                    width: 100,
                    click: () => {
                        $$('myForm').setValues($$('myForm').getCleanValues());
                        $$('CountrySelect').setValue($$('myForm').getCleanValues().CountrySelect);
                        $$('Datepicker').setValue('');
                    },
                },
                {
                    view: 'button',
                    value: _('Consultar'),
                    hotkey: 'enter',
                    type: 'form',
                    width: 110,
                    id: 'consultDesk',
                    click: () => {
                        const filterdata = this.getRoot().getValues();
                        if (devConfig.getCountryReport()) {
                            filterdata.CountrySelect = profile.Settings.ReportCountry;
                        }
                        delete filterdata['CountrySelect2'];
                        if (profile.typeDate !== 2) {
                            delete filterdata['Date'];
                        } else {
                            if (true) {
                                delete filterdata['Datepicker'];
                            }
                        }
                        this.app.callEvent('depositReport:filter', [filterdata]);
                        $$('b5').collapse();
                        $$('a5').scrollTo(100, 0);
                    },
                },
            ],
        };
        const buttons2 = {
            padding: 10,
            cols: [
                {
                    view: 'button',
                    value: _('Limpiar'),
                    click: () => {
                        $$('myForm2').setValues($$('myForm2').getCleanValues());
                        $$('CountrySelect').setValue($$('myForm2').getCleanValues().CountrySelect);
                        $$('Datepicker').setValue('');
                    },
                },
                {
                    view: 'button',
                    value: _('Consultar'),
                    hotkey: 'enter',
                    type: 'form',
                    click: () => {
                        const filterdata = $$('myForm2').getValues();
                        if (devConfig.getCountryReport()) {
                            filterdata.CountrySelect = profile.Settings.ReportCountry;
                        }
                        delete filterdata['CountrySelect2'];
                        if (profile.typeDate !== 2) {
                            delete filterdata['Date'];
                        } else {
                            if (true) {
                                delete filterdata['Datepicker'];
                            }
                        }
                        this.app.callEvent('depositReport:filter', [filterdata]);
                    },
                },
            ],
        };
        const accordion_section2 = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: true,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'),
                            id: 'b5',
                            body: {
                                padding: 10,
                                rows: [upper_section, buttons],
                            },
                        },
                    ],
                },
            ],
        };
        const accordion_section3 = {
            view: 'scrollview',
            scroll: 'xy',
            body: {
                padding: 10,
                rows: [upper_section],
            },
        };
        const filterPopup = webix.ui({
            view: 'window',
            move: true,
            id: 'filterPopup',
            fullscreen: true,
            head: {
                view: 'toolbar',
                cols: [
                    { view: 'label', label: _('Filtros'), align: 'center' },
                    {
                        view: 'icon',
                        icon: 'wxi-close',
                        click: function () {
                            this.getTopParentView().hide();
                        },
                    },
                ],
            },
            modal: true,
            position: 'center',
            body: {
                view: 'form',
                id: 'myForm2',
                type: 'clean',
                rows: [accordion_section3, buttons2],
                rules: {
                    fname: webix.rules.isNotEmpty,
                },
            },
        });
        return {
            view: 'form',
            id: 'myForm',
            type: 'clean',
            rows: [screen.width > 500 && screen.height > 500 ? accordion_section2 : { height: 1, width: 0 }],
            rules: {
                fname: webix.rules.isNotEmpty,
            },
        };
    }

    /**
     * Initializes the view and sets up event handlers.
     * @param {Object} grid - The grid object.
     */
    init(grid) {
        $$('Sort').hide();
        $$('IsDetails').attachEvent('onChange', function (newv, oldv) {
            if ($$('IsDetails').getValue() == '1') {
                if (screen.width < 500) {
                    $$('upper_section').define('height', 300);
                }
                $$('Sort').hide();
            } else {
                if (screen.width < 500) {
                    $$('upper_section').define('height', 380);
                }
                $$('Sort').show();
            }
        });
        webix.ready(function () {
            if (screen.width < 500) {
                $$('grav2').hide();
                $$('grav3').hide();
            }
            if (profile.typeDate !== 2) {
                $$('Date').hide();
                $$('Datepicker').show();
            } else {
                if (true) {
                    $$('Date').show();
                    $$('Datepicker').hide();
                }
            }
        });
        const lang = this.app.getService('locale').getLang();
        $$('Datepicker').attachEvent('onAfterRender', function () {
            devConfig.setDateModal(lang);
        });
        if ($$('ProvidersPaymentSystem') != undefined) {
            $$('ProvidersPaymentSystem').attachEvent('onItemClick', function (id, e) {
                webix
                    .ajax()
                    .headers({
                        'Content-type': 'application/json',
                    })
                    .post(devConfig.geturlApi() + 'Report/GetProvidersPaymentSystem', '', {
                        error: function (text, data, XmlHttpRequest) {
                            webix.message('Error! ');
                        },
                        success: function (text, data, XmlHttpRequest) {
                            var resp = JSON.parse(text);
                            for (var i = 0; i < resp.Data.length; i++) {
                                resp.Data[i].id = resp.Data[i].Id;
                                resp.Data[i].value = resp.Data[i].Name;
                            }
                            $$('ProvidersPaymentSystem').define('options', resp.Data);
                            $$('ProvidersPaymentSystem').refresh();
                        },
                    });
            });
        }
    }
}

// FILE DOCUMENTED
